import { render, staticRenderFns } from "./TabTrustees.vue?vue&type=template&id=14140c71&"
import script from "./TabTrustees.vue?vue&type=script&lang=js&"
export * from "./TabTrustees.vue?vue&type=script&lang=js&"
import style0 from "./TabTrustees.vue?vue&type=style&index=0&id=14140c71&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports